module.exports = __webpack_public_path__ + "static/1269311298.9c80edcb.jpg";